import React, { useCallback, useState } from 'react';
import { Radio } from '@cian/ui-kit';

import { ListItemContent } from '../ListItemContent';
import { ListItem } from '../ListItem';
import { IPollInfoAnswerSchema } from '../../../../repositories/journal/entities/poll/PollInfoAnswerSchema';
import * as s from './RadioListItem.css';

interface IListItem extends IPollInfoAnswerSchema {
  pollId: number;
  isDisabled?: boolean;
  onChange(isChecked: boolean): void;
}

/**
 * Элемент списка с радио
 */
export const RadioListItem = ({ id, image, name, pollId, isDisabled, onChange }: IListItem) => {
  const [isChecked, setIsChecked] = useState(false);
  const style = isChecked ? { background: 'var(--solid-red60)' } : {};

  const handleChange = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onChange(true);
      setIsChecked(!isChecked);
    },
    [isChecked, onChange],
  );

  return (
    <ListItem onClick={!isDisabled ? handleChange : undefined} style={style}>
      <ListItemContent image={image} name={name}>
        <div className={s['radio']}>
          <Radio name={`PostPollRadio${pollId}`} value={`${id}`} disabled={isDisabled} checked={isChecked} />
        </div>
      </ListItemContent>
    </ListItem>
  );
};
